import { useState } from 'react';
import { Grid, Tooltip, IconButton } from '@mui/material';
import Table from '../../components/Table';
import CustomButton from 'components/Button';
import AddIcon from '@mui/icons-material/Add';
import SuccessError from 'components/SuccessError';
import { tableOptionFilter } from 'utils/utils';
import Loader from 'components/Loader';
import { useSelector } from 'react-redux';
import { authPostRequest, getAuthRequest } from 'Api/api';
import { useEffect } from 'react';
import CreateAndUpdateBracketPrice from './CreateAndUpdateBracketPrice';
import DeleteSpan from 'components/DeleteSpan';
import DialogBox from '../../components/DialogBox';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import SuperAdminView from 'pages/adminsView/SuperAdminView';
import { useNavigate } from 'react-router-dom';
import { isAdmin, isUser, isAreaAdmin } from 'utils/utils';
import TextEllipsize from 'utils/TextEllipsize';

const columnOptionsStrengths = {
  setCellProps: () => ({ style: { maxWidth: '200px' } }),
  customBodyRender: (value) => <TextEllipsize value={value} length={30} />
};

const columns = [
  {
    name: 'name',
    label: 'Name',
    options: {
      filter: true,
      sort: false
    },
    ...columnOptionsStrengths
  },

  {
    name: 'bracketType',
    label: 'Bracket Type',
    options: {
      filter: true,
      sort: false
    },
    ...columnOptionsStrengths
  },

  {
    name: 'materialType',
    label: 'Material Type',
    options: {
      filter: true,
      sort: false
    },
    ...columnOptionsStrengths
  },

  {
    name: 'wholesalePrice',
    label: 'Wholesale Price ($)',
    options: {
      filter: true,
      sort: false,

      customBodyRender: (value) => (value ? parseFloat(value)?.toFixed(2) : 'Call')
    }
  },

  {
    name: 'contractorPrice',
    label: 'Contractor Price ($)',
    options: {
      filter: true,
      sort: false,

      customBodyRender: (value) => (value ? parseFloat(value)?.toFixed(2) : 'Call')
    }
  },

  {
    name: 'manufacturerPrice',
    label: 'Manufacturer Price ($)',
    options: {
      filter: true,
      sort: false,

      customBodyRender: (value) => (value ? parseFloat(value)?.toFixed(2) : 'Call')
    }
  },

  {
    name: 'retailerPrice',
    label: 'Retailer Price ($)',
    options: {
      filter: true,
      sort: false,

      customBodyRender: (value) => (value ? parseFloat(value)?.toFixed(2) : 'Call')
    }
  }
];

const BracketPrices = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [addOpenModal, setAddOpenModal] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showAlertBar, setShowAlertBar] = useState(false);
  const [isFormSaved, setIsFormSaved] = useState(false);
  const [successMessage, setSuccessMessage] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [bracket, setBracket] = useState();
  const [brackets, setBrackets] = useState();
  const [isDeleted, setIsDeleted] = useState(false);

  const { userData, adminAccess } = useSelector((store) => store.auth);
  const navigate = useNavigate();

  //For Open Dialog for delete user
  const handleDialogOpen = (bracket) => {
    setBracket(brackets[bracket]);
    setOpenDialog(true);
  };

  //For Open Dialog for update user
  const handleOpenModal = (bracket) => {
    setBracket(brackets[bracket]);
    setAddOpenModal(true);
  };

  //Handle confirmation for delete
  const handleConfirm = async () => {
    try {
      const params = {
        userId: userData.userId,
        bracketId: bracket?.bracketId,
        materialTypeId: bracket?.materialTypeId
      };
      setShowLoader(true);
      setShowAlertBar(false);
      setIsDeleted(false);
      const deleteBracket = await authPostRequest('deleteBracket', params);
      setShowLoader(false);
      if (deleteBracket.resStatus === 1) {
        setSuccessMessage([deleteBracket.resMessage]);
        setIsDeleted(true);
      } else {
        setErrorMessage([deleteBracket.resMessage]);
      }
      setIsFormSaved(true);

      setShowAlertBar(true);
      setOpenDialog(!openDialog);
      window.scrollTo(0, 0);
    } catch (err) {
      setErrorMessage(['Error']);
      window.scrollTo(0, 0);
    }
  };

  //state set from delete bracket
  const handleDialogState = () => {
    setOpenDialog(!openDialog);
  };

  const getBracketPriceList = async () => {
    try {
      setShowLoader(true);
      const list = await getAuthRequest('getBracketsList');

      setBrackets(list?.bracketPricesList);
      setShowLoader(false);
    } catch (err) {
      setShowLoader(false);
      console.log(err);
    }
  };
  useEffect(() => {
    getBracketPriceList();
    if (isAdmin(userData?.roles) || isUser(userData?.roles) || isAreaAdmin(userData?.roles)) {
      if (adminAccess) {
        console.log('bracket price');
        navigate('/Error');
      } else navigate('/403');
    }
  }, [isFormSaved, isDeleted]);

  return (
    <>
      <SuperAdminView />
      <Grid display="flex" alignItems="center" justifyContent="flex-end">
        {showAlertBar && (
          <SuccessError
            successMessage={successMessage}
            errorMessage={errorMessage}
            setShowAlertBar={setShowAlertBar}
          />
        )}
        <CustomButton
          add={true}
          type="submit"
          endIcon={<AddIcon />}
          sx={{ display: 'none' }}
          onClick={() => {
            setBracket({
              name: '',
              wholesalePrice: '',
              contractorPrice: '',
              manufacturerPrice: '',
              retailerPrice: '',
              type: '',
              material: ''
            });
            setAddOpenModal(true);
          }}>
          Add
        </CustomButton>
      </Grid>

      <Table
        data={brackets}
        options={tableOptionFilter}
        columns={[
          ...columns,
          {
            name: 'Actions',
            lable: 'Actions',
            options: {
              filter: false,
              sort: false,

              // Delete and Update Actions
              customBodyRender: (value, tableMeta) => {
                return (
                  <Grid sx={{ ml: '-1.5vh' }}>
                    <>
                      <Tooltip sx={{ display: 'none' }} title="Delete">
                        <IconButton
                          onClick={() => {
                            handleDialogOpen(tableMeta.rowIndex);
                          }}>
                          <DeleteForeverIcon style={{ color: '#800000' }} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Update">
                        <IconButton
                          onClick={() => {
                            handleOpenModal(tableMeta.rowIndex);
                          }}>
                          <EditIcon style={{ color: '#040273' }} />
                        </IconButton>
                      </Tooltip>
                    </>
                  </Grid>
                );
              }
            }
          }
        ]}
      />

      {showLoader && <Loader open={showLoader} />}

      {openDialog && (
        <DialogBox
          handleDialogBoxState={handleDialogState}
          openDialogBox={openDialog}
          handleConfirmAction={handleConfirm}
          deleteMessage={<DeleteSpan message="bracket  " toBeDel={bracket.name} />}
        />
      )}

      {addOpenModal && (
        <CreateAndUpdateBracketPrice
          bracket={bracket}
          addOpenModal={addOpenModal}
          setAddOpenModal={setAddOpenModal}
          setSuccess={setSuccessMessage}
          setAlertBar={setShowAlertBar}
          setIsFormSaved={setIsFormSaved}
          isFormSaved={isFormSaved}
        />
      )}
    </>
  );
};

export default BracketPrices;
